import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";

function Footer(props) {
  const authCtx = props.authCtx;
  const [subcategories, setSubcategories] = useState([]);
  const getSubcategories = () => {
    fetch(authCtx.baseUrl + "subcategories")
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        setSubcategories(data);
      });
  };
  useEffect(() => {
    getSubcategories();
  }, []);
  return (
    <Fragment>
      {/* <div className="footer_row mt-20">
        <div className="col">
          <img src="static/images/shipping.png" alt="" />
          <p>Free shipping</p>
        </div>
        <div className="col">
          <img src="static/images/secure.png" alt="" />
          <p>Secure payment</p>
        </div>
        <div className="col">
          <img src="static/images/policy.png" alt="" />
          <p>Warranty policy</p>
        </div>
      </div> */}
      <footer className="px-5 sm:px-32 pt-10 pb-5 mt-40">
        <div className="col">
          <h1>Our products</h1>
          <ul>
            {subcategories.map((subcategory, i) => (
              <li key={i}>
                <Link to={"/products/" + subcategory.slug}>
                  {subcategory.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col">
          <h1>About Coocaa</h1>
          <ul>
            <li>
              <Link to="/about">About Coocaa</Link>
            </li>
            {/* <li>Retail Store</li> 
            <li>FAQ</li>
            <li>User Guide</li> */}
            <li><Link to="/service-centers">Service Centers</Link></li>
          </ul>
        </div>
        <div className="col">
          <h1>Contact Coocaa</h1>
          <p>
            Toll free Support :{" "}
            <b>
              <a href="tel:1800-12344-6666">1800-12344-6666</a>
            </b>
          </p>
          <p>
            Sales :{" "}
            <b>
              <a href="tel:091212 58575">091212 58575</a>
            </b>
          </p>
          <p>
            <a href="mailto:contactus@coocaatv.in">contactus@coocaatv.in</a>
          </p>
          <br />
          <h1>Follow Us</h1>
          <div className="icon_row">
            <a target="_blank" href="https://www.facebook.com/CoocaaTV">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 44C34.4934 44 43 35.4934 43 25C43 14.5066 34.4934 6 24 6C13.5066 6 5 14.5066 5 25C5 35.4934 13.5066 44 24 44Z"
                  fill="white"
                />
                <path
                  d="M44 24.1217C44 13.0096 35.0449 4 24 4C12.9551 4 4 13.0096 4 24.1217C4 34.1641 11.3126 42.489 20.8753 44V29.9394H15.7958V24.1217H20.8753V19.6876C20.8753 14.6452 23.8622 11.858 28.4298 11.858C30.6179 11.858 32.9073 12.2513 32.9073 12.2513V17.2032H30.3845C27.901 17.2032 27.1247 18.7538 27.1247 20.3469V24.1217H32.6711L31.7851 29.9394H27.1247V44C36.6874 42.4918 44 34.167 44 24.1217Z"
                  fill="black"
                  className="color"
                />
              </svg>
            </a>

            <a target="_blank" href="https://twitter.com/CoocaaIndia">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                  fill="black"
                  className="color"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M36 18.0708C35.2355 18.469 34.3012 18.708 33.4517 18.7876C34.3861 18.2301 35.0656 17.354 35.4054 16.3186C34.556 16.7965 33.6216 17.1947 32.5174 17.4336C31.668 16.5575 30.5637 16 29.2896 16C26.8263 16 24.7876 17.9912 24.7876 20.5398C24.7876 20.8584 24.7876 21.2566 24.8726 21.5752C21.1351 21.4159 17.8224 19.5841 15.6139 16.8761C15.1892 17.5133 15.0193 18.3097 15.0193 19.1858C15.0193 20.7788 15.7838 22.1327 16.973 22.9292C16.2085 22.9292 15.529 22.6903 14.9344 22.3717V22.4513C14.9344 24.6018 16.4633 26.4336 18.5019 26.9115C18.1622 26.9912 17.7375 27.0708 17.3127 27.0708C17.0579 27.0708 16.7181 27.0708 16.4633 26.9911C17.0579 28.823 18.6718 30.0973 20.6255 30.0973C19.0965 31.292 17.1429 32.0089 15.1042 32.0089C14.7645 32.0089 14.4247 32.0088 14 31.9292C15.9537 33.2035 18.332 34 20.8803 34C29.1197 34 33.6216 27.1504 33.6216 21.177C33.6216 21.0177 33.6216 20.7788 33.6216 20.6195C34.6409 19.823 35.4054 19.0265 36 18.0708Z"
                  fill="white"
                />
              </svg>
            </a>

            <a
              target="_blank"
              href="https://www.youtube.com/channel/UCAa7P4OZBt1MPZiODDnIn8w"
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                  fill="black"
                  className="color"
                />
                <path
                  d="M36.2675 17.7229C35.9809 16.6561 35.1369 15.8121 34.0701 15.5255C32.1433 15 24.3885 15 24.3885 15C24.3885 15 16.6338 15.0159 14.707 15.5414C13.6401 15.828 12.7962 16.672 12.5096 17.7389C12 19.6656 12 23.6943 12 23.6943C12 23.6943 12 27.7229 12.5255 29.6656C12.8121 30.7325 13.6561 31.5764 14.7229 31.8631C16.6497 32.3885 24.4045 32.3885 24.4045 32.3885C24.4045 32.3885 32.1592 32.3885 34.086 31.8631C35.1529 31.5764 35.9968 30.7325 36.2834 29.6656C36.8089 27.7389 36.8089 23.6943 36.8089 23.6943C36.8089 23.6943 36.793 19.6656 36.2675 17.7229Z"
                  fill="white"
                />
                <path
                  d="M21.9204 27.421L28.3535 23.6949L21.9204 19.9688V27.421Z"
                  fill="black"
                  className="color"
                />
              </svg>
            </a>

            <a
              target="_blank"
              href="https://www.instagram.com/coocaa_india/?hl=en"
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                  fill="black"
                  className="color"
                />
                <path
                  d="M34.9339 19.4648C34.8803 18.2939 34.6944 17.4943 34.4224 16.7947C34.1463 16.0607 33.7133 15.3958 33.1537 14.8463C32.6043 14.2867 31.9393 13.8535 31.2053 13.5772C30.5056 13.3055 29.7061 13.1197 28.5352 13.0665C27.3621 13.0128 26.9873 13 24 13C21.0127 13 20.6379 13.0128 19.4648 13.0661C18.2939 13.1197 17.4944 13.3056 16.7947 13.5776C16.0607 13.8537 15.3958 14.2867 14.8463 14.8463C14.2867 15.3957 13.8535 16.0605 13.5772 16.7945C13.3055 17.4943 13.1197 18.2939 13.0665 19.4646C13.0128 20.6379 13 21.0125 13 23.9998C13 26.9873 13.0128 27.3621 13.0665 28.5352C13.1198 29.7059 13.3058 30.5056 13.5777 31.2053C13.8538 31.9391 14.2869 32.6042 14.8465 33.1535C15.3958 33.7131 16.0609 34.1462 16.7948 34.4223C17.4944 34.6944 18.2941 34.8802 19.465 34.9337C20.6382 34.9872 21.0128 34.9998 24.0002 34.9998C26.9875 34.9998 27.3623 34.9872 28.5354 34.9337C29.7063 34.8802 30.5057 34.6944 31.2055 34.4223C32.683 33.8509 33.8511 32.6829 34.4224 31.2053C34.6945 30.5056 34.8803 29.7059 34.9339 28.5352C34.9872 27.362 35 26.9873 35 24C35 21.0125 34.9872 20.6379 34.9339 19.4648ZM32.9538 28.4451C32.9049 29.5176 32.7257 30.1001 32.5751 30.4876C32.205 31.447 31.4469 32.2052 30.4874 32.5753C30.0999 32.7258 29.5175 32.9051 28.4449 32.9539C27.2853 33.007 26.9373 33.0181 24 33.0181C21.0625 33.0181 20.7147 33.007 19.5549 32.9539C18.4825 32.9051 17.9001 32.7258 17.5124 32.5753C17.0347 32.3989 16.6025 32.1177 16.2477 31.7523C15.8823 31.3975 15.6011 30.9655 15.4247 30.4876C15.2742 30.1001 15.0949 29.5176 15.0461 28.4451C14.9932 27.2853 14.9819 26.9373 14.9819 24.0002C14.9819 21.0629 14.9932 20.7151 15.0461 19.5551C15.0951 18.4825 15.2742 17.9001 15.4247 17.5126C15.6011 17.0347 15.8824 16.6025 16.2477 16.2477C16.6025 15.8823 17.0347 15.6011 17.5126 15.4249C17.9001 15.2742 18.4825 15.0951 19.5551 15.0461C20.7149 14.9932 21.0629 14.9819 24 14.9819H23.9998C26.937 14.9819 27.2849 14.9932 28.4449 15.0462C29.5175 15.0951 30.0997 15.2743 30.4874 15.4249C30.9651 15.6013 31.3973 15.8824 31.7522 16.2477C32.1176 16.6025 32.3987 17.0347 32.575 17.5126C32.7257 17.9001 32.9049 18.4825 32.9538 19.5551C33.0067 20.7149 33.0179 21.0629 33.0179 24C33.0179 26.9373 33.0068 27.2851 32.9538 28.4451Z"
                  fill="white"
                />
                <path
                  d="M23.9998 18.3516C20.8802 18.3516 18.3513 20.8807 18.3513 24.0003C18.3513 27.1199 20.8802 29.6488 23.9998 29.6488C27.1196 29.6488 29.6485 27.1199 29.6485 24.0003C29.6485 20.8807 27.1196 18.3516 23.9998 18.3516ZM23.9998 27.6669C21.9749 27.6667 20.3332 26.0252 20.3334 24.0001C20.3334 21.9752 21.9749 20.3335 24 20.3335C26.0251 20.3337 27.6666 21.9752 27.6666 24.0001C27.6666 26.0252 26.0249 27.6669 23.9998 27.6669Z"
                  fill="white"
                />
                <path
                  d="M31.1917 18.1287C31.1917 18.8577 30.6007 19.4487 29.8718 19.4487C29.1427 19.4487 28.5517 18.8577 28.5517 18.1287C28.5517 17.3996 29.1427 16.8086 29.8718 16.8086C30.6007 16.8086 31.1917 17.3996 31.1917 18.1287Z"
                  fill="white"
                />
              </svg>
            </a>

            <a
              target="_blank"
              className="ml-1"
              href="https://www.linkedin.com/company/coocaa-india/"
            >
              <svg
                width="42"
                height="42"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                  fill="black"
                  className="color"
                />
                <path
                  d="M20 7.51953C13.1074 7.51953 7.52002 13.1069 7.52002 19.9995C7.52002 26.8921 13.1074 32.4795 20 32.4795C26.8926 32.4795 32.48 26.8921 32.48 19.9995C32.48 13.1069 26.8926 7.51953 20 7.51953ZM16.945 25.1722H14.4178V17.0394H16.945V25.1722ZM15.6658 16.041C14.8676 16.041 14.3515 15.4755 14.3515 14.7761C14.3515 14.0624 14.8832 13.5138 15.6983 13.5138C16.5134 13.5138 17.0126 14.0624 17.0282 14.7761C17.0282 15.4755 16.5134 16.041 15.6658 16.041ZM26.175 25.1722H23.6478V20.6651C23.6478 19.616 23.2812 18.9036 22.3673 18.9036C21.6692 18.9036 21.2545 19.3859 21.0712 19.85C21.0036 20.0151 20.9867 20.2491 20.9867 20.4818V25.1709H18.4582V19.6329C18.4582 18.6176 18.4257 17.7687 18.3919 17.0381H20.5876L20.7033 18.1678H20.754C21.0868 17.6374 21.9019 16.8548 23.2656 16.8548C24.9283 16.8548 26.175 17.9689 26.175 20.3635V25.1722Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="bottom sm:mt-10 pt-5">
          <small>© 2018-2022 coocaa. All Rights Reserved.</small>
          <small>
            Made with Love <b>Saadiweb</b>
          </small>
          <small>
            <Link to="/privacy-policy">
              <span>Privacy Policy</span>
            </Link>
            {/* <span className="mx-2">|</span>
            <span>Terms of Sales</span> */}
            <span className="mx-2">|</span>
            <Link to="/warranty-policy">
              <span>Warranty Policy</span>
            </Link>
          </small>
        </div>
      </footer>
    </Fragment>
  );
}

export default Footer;
